import { ClientData } from '@core/models/client-data.model';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '@redux/actions';

export const initialClientDataState: ClientData = {
  clientId: '',
  clientIdentityDocumentNumber: '',
  clientName: '',
  clientSurnames: '',
  clientBirthdate: new Date(),
  clientPhone: '',
  clientEmail: '',
  clientEncryptedToken: '',
};

const _clientDataReducer = createReducer(
  initialClientDataState,
  on(actions.clientDataEdit, (state, { clientData }) => {
    return clientData;
  }),
  on(actions.clientDataEditEncryptedToken, (state, { encryptedToken }) => {
    return { ...state, clientEncryptedToken: encryptedToken };
  })
);

export function clientDataReducer(
  state: ClientData | undefined,
  action: Action
) {
  return _clientDataReducer(state, action);
}
